/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Page_Pricing_TitleInputs */

const en_cad_page_pricing_title = /** @type {(inputs: Cad_Page_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft Online Pricing: Free Editor, Pro Cloud Drawings`)
};

/**
* | output |
* | --- |
* | "CADCraft Online Pricing: Free Editor, Pro Cloud Drawings" |
*
* @param {Cad_Page_Pricing_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_page_pricing_title = /** @type {((inputs?: Cad_Page_Pricing_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Page_Pricing_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_page_pricing_title(inputs)
});
export { cad_page_pricing_title as "cad.page.pricing.title" }